import React, { useEffect, useState } from "react";
import "./Navbar.scss";
import { IStructureElement } from "../../../types/IStructureElement";
import { useSite } from "../../../hooks/useSite";

export default function Navbar({ id }: IStructureElement) {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const { sites, fetchSite } = useSite();

    const init = async () => {
        await fetchSite();
    };

    useEffect(() => { init(); }, []);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 20);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = isMobileMenuOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [isMobileMenuOpen]);

    const toggleMobileMenu = () => setIsMobileMenuOpen(prev => !prev);
    const closeMobileMenu  = () => setIsMobileMenuOpen(false);

    const navigation = sites.map(el => ({ name: el.name, href: "/" + el.slug }));

    return (
        <nav className={`navbar ${isScrolled ? "navbar--scrolled" : ""}`}>
            <div className="navbar__container">

                <a href="/" className="navbar__logo">
                    <span className="navbar__logo-cross">✝</span>
                    <span className="navbar__logo-text">
                        <span className="navbar__logo-main">Parafia Wniebowzięcia</span>
                        <span className="navbar__logo-sub">Najświętszej Maryi Panny w Rogowie</span>
                    </span>
                </a>

                <ul className="navbar__menu">
                    {navigation.map(item => (
                        <li key={item.name}>
                            <a href={item.href} className="navbar__menu-item">{item.name}</a>
                        </li>
                    ))}
                </ul>

                <button
                    className={`navbar__burger ${isMobileMenuOpen ? "navbar__burger--open" : ""}`}
                    onClick={toggleMobileMenu}
                    aria-label={isMobileMenuOpen ? "Zamknij menu" : "Otwórz menu"}
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>

            <div className={`navbar__overlay ${isMobileMenuOpen ? "navbar__overlay--open" : ""}`}>
                <a href="/" className="navbar__overlay-logo" onClick={closeMobileMenu}>
                    <span className="navbar__logo-cross">✝</span>
                    <span className="navbar__logo-text">
                        <span className="navbar__logo-main">Parafia Wniebowzięcia</span>
                        <span className="navbar__logo-sub">Najświętszej Maryi Panny w Rogowie</span>
                    </span>
                </a>
                <ul className="navbar__overlay-list">
                    {navigation.map(item => (
                        <li key={item.name} className="navbar__overlay-item">
                            <a href={item.href} className="navbar__overlay-link" onClick={closeMobileMenu}>
                                {item.name}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
}
